import { authedRequest, unauthedRequest } from './requests'

/**
 *
 * /session resource requests
 *
 */
export const postSession =
  ({ email, password }) =>
    unauthedRequest('v2/users/sign-in', {
      method: 'POST',
      body: JSON.stringify({
        user: {
          email,
          password,
        }
      })
    });

export const resendVerificationEmail =
  ({email}) => 
      unauthedRequest('v2/session/resend-verification-instructions', {
        method: 'POST',
        body: JSON.stringify({
          user: {
            email,
          }
        })
      });


export const getSession =
  (token) => authedRequest('v2/session', token);

export const deleteSession =
  (token) =>
    authedRequest('session', token, { method: 'DELETE' });
